export function countWords(content: object): number {
  try {
    const json = content as {
      content?: Array<{
        type?: string;
        content?: Array<{ text?: string; content?: Array<{ text?: string }> }>;
      }>;
    };
    let text = "";
    function walk(nodes: Array<{ text?: string; content?: unknown[] }>) {
      for (const node of nodes) {
        if (node.text) text += " " + node.text;
        if (Array.isArray(node.content)) walk(node.content as Array<{ text?: string; content?: unknown[] }>);
      }
    }
    if (json.content) walk(json.content as Array<{ text?: string; content?: unknown[] }>);
    return text
      .trim()
      .split(/\s+/)
      .filter(Boolean).length;
  } catch {
    return 0;
  }
}
